define.alias("shared/helpers/to-fixed", "settings/helpers/to-fixed");